module.exports = __webpack_public_path__ + "static/media/md_avatar_wizard.25ef120f.png";